export class AgendaEvent {
    constructor() {
        this.id = null ;
        this.ref = null;
        this.type_id = null;
        this.type= null ;
        this.title = null;
        this.note_private = null;
        this.datec = null ;
        this.duree= null;
        this.datem = null;
        this.start = null ;
        this.end= null;
        this.product_ref =null;
        this.libelle = null ;
    }

    bindAgendaEvent(agendaEventJson) {

        this.id = agendaEventJson.id ;
        this.ref = agendaEventJson.ref;
        this.type_id = agendaEventJson.type_id;
        this.type= agendaEventJson.type;
        this.title = agendaEventJson.label;
        this.note_private = agendaEventJson.note_private;
        this.datec = agendaEventJson.datec;
        this.duree= agendaEventJson.duree;
        this.datem = agendaEventJson.datem;
        this.start = new Date(0);
        this.start.setUTCSeconds(agendaEventJson.datep);
        this.end = new Date(0);
        this.end.setUTCSeconds(agendaEventJson.datef);
        this.product_ref =agendaEventJson.product_ref;
        this.libelle = agendaEventJson.libelle ;
    }
}